import { useEffect, useState } from 'react';
import { OmniSearch as OmniSearchUI, type OmniSearchProps } from '@aether/ui/app-shared/OmniSearch';
import { matchPath, useLocation, useMatch } from 'react-router';

import { useOmniSearchItems } from './OmniSearchItemsProvider';

export const OmniSearch = ({
  placeholder = 'Search for fund ISIN or portfolio name …',
  ...props
}: Omit<OmniSearchProps, 'data'>) => {
  const location = useLocation();
  const items = useOmniSearchItems();
  const [isSearchOpen, setIsSearchOpen] = useState(
    Boolean(matchPath({ path: '/analyze-portfolio' }, location.pathname))
  );
  const match = useMatch('/:basePath/:id/*');

  useEffect(() => {
    setIsSearchOpen(Boolean(matchPath({ path: '/analyze-portfolio' }, location.pathname)));
  }, [location.pathname]);

  return (
    <OmniSearchUI
      {...props}
      itemUrl={
        match?.params.basePath?.match(/funds|strategies|ai-enhanced/) &&
        match?.params.id?.match(/\b([A-Z]{2})((?![A-Z]{10}\b)[A-Z0-9]{10})\b|0x+/) // isin or strategy ID
          ? item => (item.url ? `${new URL(item.url).pathname.replace(/[/]+$/, '')}/${match.params['*']}` : '')
          : undefined
      }
      data={items}
      placeholder={placeholder}
      isOpen={isSearchOpen}
      hideFundsOnEmptySearch={props.hideFundsOnEmptySearch || false}
    />
  );
};
